import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {

  // Number of elements per page
  @Input() quantity: number;
  // This property shows the maximum number of elements to handle
  @Input() maxQuantity: number;
  // Maximum number of pages to display
  @Input() maxSize: number = 5;
  // Emits an event when user changes to another page
  @Output() changePageEvent = new EventEmitter();
  //PAginator actual page 
  @Input() actualPage: number = 1;

  /**
   * This function gets the current page and emits an event with the actual page
   * @param {number} page
   */
  onChangePage(page: number): void {
    this.actualPage = page;
    this.changePageEvent.emit(this.actualPage);
  }
}